import Plugins from 'util/plugins';
import FormHelpers from './util/form';
import Accordion from './components/accordion';
import AccordionPdp from './components/accordionPdp';
import search from './components/search';
import Footer from './components/footer';
import Menu from './components/mainMenu';
import Header from './components/header';
import Scroller from './components/scroller';
import Minicart from './components/miniCart';
// import Bubble from './components/bubbleChat';
import { processInclude, enqueueTask, cookieExists, getCookie } from './util/common';
import AnalyticsHelper from './analyticsHelper';
import Geoblock from './components/geoblock';
import HomepageComponents from './components/homepage';
import PrimaryImagesScroller from './components/primaryImagesScroller';
import PrivacyPopUpFlag from './components/privacyPolicyPopUp';
import PromoStrip from './components/promoStrip';
import Prehome from './components/prehome';
import ProfileEnrich from './profileEnrich';
import ChosenAudioeye from  './components/chosenAudioeye';

// Global variable
window.raf = window.requestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.msRequestAnimationFrame
    || function (cb) { return setTimeout(cb, 16); };

// Init Intimissimi App
document.addEventListener('DOMContentLoaded', () => {
    console.log('Intimissimi app started.');
    processInclude(require('./components/messageHeroBanner'));
    ProfileEnrich.initOutsideClickHandler();
    // processInclude(require('./components/tabsComponents'));
    Plugins.init();
    Header.init();

    try {
        Geoblock.init();
    } catch (e) {
    }

    FormHelpers.init();
    Footer.init();
    Menu.init();
    Minicart.run();
    PromoStrip.init();
    Prehome.init();
    search();
    enqueueTask(function () {
        Accordion.setup();
        AccordionPdp.setup();
        Scroller.init();
        PrimaryImagesScroller.init();
    });
    enqueueTask(function () {
        processInclude(require('./components/carouselComponents'));
    });
    enqueueTask(function () {
        HomepageComponents.init();
    });

    AnalyticsHelper.init();

    if ($('.js-analytics-data-async').length > 0) {
        $.ajax($('.js-analytics-data-async').data('url')).then(function (rsp) {
            $('body').prepend(rsp);
        });
    }

    if (window.location.href.toLowerCase().includes('caseorigin=app')) {
        window.sessionStorage.setItem('caseorigin', 'app');
    }
    ChosenAudioeye.init();
    PrivacyPopUpFlag.init();
});
